import { render, staticRenderFns } from "./AuctionsHeader.vue?vue&type=template&id=10566295&"
import script from "./AuctionsHeader.vue?vue&type=script&lang=js&"
export * from "./AuctionsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10566295')) {
      api.createRecord('10566295', component.options)
    } else {
      api.reload('10566295', component.options)
    }
    module.hot.accept("./AuctionsHeader.vue?vue&type=template&id=10566295&", function () {
      api.rerender('10566295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/auctions/views/components/AuctionsHeader.vue"
export default component.exports